import BaseControlTypeConst from "./BaseControlTypeConst"

export default class EditorTypeConst extends BaseControlTypeConst {
 
    static FORMATS = 'formats'
    static EDITORSTYLE = 'editorStyle'  
    
    static READONLY = 'readonly'
}
